import "./wakatime.css";
export function Wakatime() {
  return (
    <>
      <div className="wakatime-badges">
        <a href="https://wakatime.com/@54678065-0087-4979-9e08-064a298c654a">
          <img
            src="https://wakatime.com/badge/user/54678065-0087-4979-9e08-064a298c654a.svg"
            alt="Total time coded since Sep 10 2025"
          />
        </a>
        {/* 
        <figure>
          <embed src="https://wakatime.com/share/@AikePetunia/e06f5ec0-fa0d-4378-82c4-40e3d081a2c9.svg"></embed>
        </figure>
    <figure>
        <embed src="https://wakatime.com/share/@AikePetunia/e380af8a-448b-44d1-ba3c-136cd544ef65.svg"></embed>
      </figure>
    */}
      </div>
    </>
  );
}

export default Wakatime;
